import { render } from "./Pharmacies.vue?vue&type=template&id=3d15d858&scoped=true&ts=true"
import script from "./Pharmacies.vue?vue&type=script&lang=ts"
export * from "./Pharmacies.vue?vue&type=script&lang=ts"

import "./Pharmacies.vue?vue&type=style&index=0&id=3d15d858&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d15d858"]])

export default __exports__